'use strict';

wbApp.directive('wbHolidayCalendarCombo', ['$timeout', '$translate', 'holidayCalendarSvc',
    function ($timeout, $translate, holidayCalendarSvc) {
        function formatResult(model) {
            if (!model) { return; }

            return model.name;
        }

        function formatSelection(model) {
            return model.name;
        }

        return {
            restrict: 'A',
            require: 'ngModel',
            priority: 1,
            replace: true,
            link: function (scope, elm, attrs, ctrl) {

                var models = holidayCalendarSvc.getAll();

                $timeout(function () {
                    $(elm).select2({
                        placeholder: $translate.instant('TXT_PLACEHOLDER_SELECT_HOLIDAY_CALENDAR'),
                        formatResult: formatResult,
                        formatSelection: formatSelection,
                        dropdownAutoWidth: true,
                        allowClear: true,
                        minimumResultsForSearch: 5,                       
                        data: models
                    });

                    ctrl.$render = function () {
                        models.$promise.then(function () {
                            $(elm).select2('val', ctrl.$viewValue);
                        });
                    }

                    elm.bind("$destroy", function () {
                        elm.select2("destroy");
                    });

                    attrs.$observe('readonly', function (value) {
                        elm.select2('readonly', !!value);
                    });

                    ctrl.$render();

                }, 1);
            }
        }
    }]);    